import {useState} from 'react'
import './content.scss'
import Portfolio from '../Components/Portfolio/Portfolio'
import Intro from   '../Components/Intro/Intro'
import Testimonials from  '../Components/Testimonials/Testimonials'
import Contact from '../Components/Contact/Contact'
import Works from '../Components/Works/Works'
import Modal from '../Components/Modal/modal'


export default function Content() {
    const [modalOpen, setmodalOpen] = useState(false)
    return (
        <div className='content'>
            { modalOpen && <Modal setmodalOpen={setmodalOpen} modalOpen={modalOpen}/>}
            <Intro />
            <Portfolio />
            <Works />
            <Testimonials />
            <Contact modalOpen={modalOpen} setmodalOpen={setmodalOpen}/>
        </div>
    )
}
